const freeCodeCampCDN = document.createElement('script')
freeCodeCampCDN.src =
  'https://cdn.freecodecamp.org/testable-projects-fcc/v1/bundle.js'
document.body.appendChild(freeCodeCampCDN)
